export default __webpack_public_path__ + "static/2-15d434a959928b66e95fe29d3afc2073.jpeg";